/* eslint-disable eqeqeq */
import React, { useEffect, useState, useRef, useMemo } from "react";
import { API_URL, IMAGE_PATH } from "../config/AppConfig";
import "../assets/css/profile.scss";
import Breadcrumbs from "../components/Breadcrumbs";
import {
  RiEyeFill,
  RiEyeOffFill,
} from "react-icons/ri";
import {
  FiMail,
  FiPhone,
  FiMapPin,
  FiGlobe,
  FiMessageSquare,
  FiSend,
  FiHelpCircle,
  FiChevronDown,
  FiUser,
} from "react-icons/fi";
import axios from "axios";
const Swal = require("sweetalert2");

const Profile = () => {
  const [activeTab, setActiveTab] = useState("profile");
  const mapRef = useRef(null);
  const markerRef = useRef(null);
  const autocompleteRef = useRef(null);

  const [form, setForm] = useState({
    owner_name: "",
    email: "",
    business_name: "",
    address: "",
    business_location: "",
    business_type: "",
    category_ids: "",
    mobile: "",
    phone_code: "+971",
    alternate_mobile: "",
    altphone_code: "+971",
    longitude: "",
    latitude: "",
    user_id: "",
  });

  const [image, setImage] = useState(null);
  const [profileData, setProfileData] = useState({});
  const [categories, setCategories] = useState([]);
  const [storedUserData, setStoredUserData] = useState(null);
  const [aboutUs, setAboutUs] = useState("");
  const [termsConditions, setTermsConditions] = useState("");
  const [privacyPolicy, setPrivacyPolicy] = useState("");
  const [contactInfo, setContactInfo] = useState("");
  const [loading, setLoading] = useState(false);
  const [faqLoading, setFaqLoading] = useState(false);
  const [contactForm, setContactForm] = useState({
    name: "",
    email: "",
    message: "",
  });
  const [faqItems, setFaqItems] = useState([]);

  const parsedContactInfo = useMemo(() => {
    if (!contactInfo) {
      return {
        email: "",
        phone: "",
        website: "",
        address: "",
      };
    }

    try {
      const parser = new DOMParser();
      const doc = parser.parseFromString(contactInfo, "text/html");
      const text = doc?.body?.textContent || contactInfo;
      const lines = text.split(/\r?\n/).map((line) => line.trim()).filter(Boolean);
      const info = lines.reduce((acc, line) => {
        const [label, ...rest] = line.split(":");
        if (!label || rest.length === 0) return acc;
        const key = label.trim().toLowerCase();
        acc[key] = rest.join(":").trim();
        return acc;
      }, {});

      return {
        email: info.email || "",
        phone: info.phone || "",
        website: info.website || "",
        address: info.address || "",
      };
    } catch (error) {
      console.error("Contact info parse error:", error);
      return {
        email: "",
        phone: "",
        website: "",
        address: "",
      };
    }
  }, [contactInfo]);

  const businessTypes = [
    { id: 1, name: "Importer" },
    { id: 2, name: "Trader" },
    { id: 3, name: "Retailer" },
  ];
  
 
  useEffect(() => {
    const loadGoogleMaps = () => {
      if (!window.google) {
        const script = document.createElement("script");
        script.src = `https://maps.googleapis.com/maps/api/js?key=AIzaSyBu_hPjmC3jAI9s0wVqyRc03AWS4p0OLxc&libraries=places`;
        script.async = true;
        document.body.appendChild(script);
        script.onload = () => initMap();
      } else {
        initMap();
      }
    };

    const initMap = () => {
      const mapElement = document.getElementById("profile-map");
      if (!mapElement) return;

      const defaultCenter = { lat: 25.2048493, lng: 55.2707828 };
      
      mapRef.current = new window.google.maps.Map(mapElement, {
        center: defaultCenter,
        zoom: 12,
      });

      markerRef.current = new window.google.maps.Marker({
        position: defaultCenter,
        map: mapRef.current,
        title: "Business Location",
        draggable: true,
      });

      markerRef.current.addListener('dragend', (e) => {
        const lat = e.latLng.lat();
        const lng = e.latLng.lng();
        setForm(prev => ({
          ...prev,
          latitude: lat.toString(),
          longitude: lng.toString(),
        }));
      });

      const input = document.getElementById("business_location_input");
      if (input) {
        autocompleteRef.current = new window.google.maps.places.Autocomplete(input);
        autocompleteRef.current.addListener("place_changed", () => {
          const place = autocompleteRef.current.getPlace();
          if (place.geometry) {
            const lat = place.geometry.location.lat();
            const lng = place.geometry.location.lng();

            setForm(prev => ({
              ...prev,
              business_location: place.formatted_address,
              latitude: lat.toString(),
              longitude: lng.toString(),
            }));

            mapRef.current.setCenter({ lat, lng });
            mapRef.current.setZoom(15);
            markerRef.current.setPosition({ lat, lng });
          }
        });
      }
    };

    if (activeTab === "profile") {
      setTimeout(loadGoogleMaps, 100);
    }
  }, [activeTab]);

  useEffect(() => {
    const fetchCategories = async () => {
      try {
        const res = await axios.get(`${API_URL}/get_category?user_id=${sessionStorage.getItem("id")}`);
        setCategories(
          res.data.categories_arr !== "NA" ? res.data.categories_arr : []
        );
      } catch (err) {
        console.error("Error fetching categories:", err);
      }
    };
    fetchCategories();
  }, []);


  useEffect(() => {
    if (mapRef.current && markerRef.current && form.latitude && form.longitude) {
      const lat = parseFloat(form.latitude);
      const lng = parseFloat(form.longitude);
      if (!isNaN(lat) && !isNaN(lng)) {
        const position = { lat, lng };
        mapRef.current.setCenter(position);
        markerRef.current.setPosition(position);
      }
    }
  }, [form.latitude, form.longitude]);

  const getUserDataFromSession = () => {
    const storedUser = sessionStorage.getItem("userData");
    if (!storedUser) {
      return null;
    }

    try {
      const parsed = JSON.parse(storedUser);
      if (Array.isArray(parsed)) {
        return parsed[0] || null;
      }
      return parsed;
    } catch (error) {
      console.warn("Invalid userData in sessionStorage:", error);
      return null;
    }
  };

  const fetchFaqItems = async () => {
    if (faqLoading || faqItems.length) return;
    setFaqLoading(true);
    try {
      const res = await axios.get(`${API_URL}/get_faq`);
      const fetchedFaqs =
        res?.data?.faq_data ||
        res?.data?.data ||
        res?.data?.faq ||
        res?.data ||
        [];

      if (Array.isArray(fetchedFaqs)) {
        setFaqItems(
          fetchedFaqs.map((item) => ({
            question: item.question || item.title || "Untitled Question",
            answer:
              item.answer ||
              item.description ||
              "Information not available at the moment.",
          }))
        );
      } else if (typeof fetchedFaqs === "object") {
        const faqArray = Object.values(fetchedFaqs);
        setFaqItems(
          faqArray.map((item) => ({
            question: item.question || item.title || "Untitled Question",
            answer:
              item.answer ||
              item.description ||
              "Information not available at the moment.",
          }))
        );
      } else {
        setFaqItems([]);
      }
    } catch (error) {
      console.error("FAQ Fetch Error:", error);
      setFaqItems([]);
    } finally {
      setFaqLoading(false);
    }
  };

  const updateSessionUserData = (updates = {}) => {
    const current = getUserDataFromSession() || {};
    const updated = { ...current, ...updates };
    sessionStorage.setItem("userData", JSON.stringify(updated));
    return updated;
  };

  const mapDealingToCategoryIds = (dealingValue, categoriesList) => {
    if (!dealingValue || !categoriesList || categoriesList.length === 0) {
      return "";
    }

    const normalizeArray = (value) => {
      if (Array.isArray(value)) return value;
      if (typeof value === "string") {
        return value
          .split(",")
          .map((item) => item.trim())
          .filter(Boolean);
      }
      return [];
    };

    const normalizedCategories = categoriesList.reduce((acc, cat) => {
      if (cat?.category_name) {
        acc[cat.category_name.toLowerCase()] = cat.category_id;
      }
      if (cat?.category_id) {
        acc[cat.category_id.toString()] = cat.category_id;
      }
      return acc;
    }, {});

    const dealingArray = normalizeArray(dealingValue);
    const resolvedIds = dealingArray
      .map((item) => {
        const lowerKey = item.toString().toLowerCase();
        return normalizedCategories[lowerKey];
      })
      .filter((id, index, arr) => id && arr.indexOf(id) === index);

    return resolvedIds.join(",");
  };

  const extractImageFromResponse = (responseData) => {
    if (!responseData) return null;

    if (responseData.image) return responseData.image;
    if (responseData.image_name) return responseData.image_name;

    if (responseData.data) {
      if (responseData.data.image) return responseData.data.image;
      if (responseData.data.image_name) return responseData.data.image_name;
    }

    if (responseData.info) {
      if (Array.isArray(responseData.info)) {
        return responseData.info[0]?.image || null;
      }
      if (responseData.info.image) {
        return responseData.info.image;
      }
    }

    return null;
  };

  const fetchProfile = () => {
    const data = getUserDataFromSession();

    if (!data) {
      console.warn("No user data found in sessionStorage");
      return;
    }

    setStoredUserData(data);
    setProfileData(data);

    const parsePhoneField = (numberValue, codeValue, defaultCode = "+971") => {
      let phoneNumber = numberValue || "";
      let phoneCode = codeValue ? codeValue.toString() : defaultCode;

      if (typeof phoneNumber === "string" && phoneNumber.includes(" ")) {
        const parts = phoneNumber.split(" ");
        if (parts.length > 1) {
          phoneCode = parts[0];
          phoneNumber = parts.slice(1).join(" ");
        }
      }

      if (phoneCode && !phoneCode.toString().startsWith("+")) {
        phoneCode = `+${phoneCode}`;
      }

      return {
        phoneNumber: phoneNumber ? phoneNumber.toString() : "",
        phoneCode,
      };
    };

    const { phoneNumber, phoneCode } = parsePhoneField(
      data.mobile,
      data.phone_code,
      "+971"
    );

    const { phoneNumber: altPhoneNumber, phoneCode: altPhoneCode } = parsePhoneField(
      data.alternate_mobile,
      data.altphone_code || data.phone_code,
      "+971"
    );

    setForm({
      owner_name: data.owner_name || data.ownername || data.username || "",
      email: data.email || "",
      business_name: data.business_name || data.businessname || "",
      address: data.address || "",
      business_location: data.business_location || "",
      business_type: data.business_type || "",
      category_ids: mapDealingToCategoryIds(data.dealing_id, categories),
      mobile: phoneNumber,
      phone_code: phoneCode,
      alternate_mobile: altPhoneNumber,
      altphone_code: altPhoneCode,
      longitude: data.longitude || "",
      latitude: data.latitude || "",
      user_id: data.user_id || "",
    });

    setImage(data.image || null);
    setContactForm((prev) => ({
      ...prev,
      email: data.email || "",
    }));
  };

  useEffect(() => {
    fetchProfile();
  }, []);

  useEffect(() => {
    setContactForm((prev) => ({
      ...prev,
      email: form.email || "",
      name: form.owner_name || "",
    }));
  }, [form.email, form.owner_name]);
 
  useEffect(() => {
    if (!storedUserData || categories.length === 0) return;
    setForm((prev) => ({
      ...prev,
      category_ids: mapDealingToCategoryIds(storedUserData.dealing_id, categories),
    }));
  }, [categories, storedUserData]);

  const fetchContentByType = async (contentType, setter) => {
    setLoading(true);
    try {
      const res = await axios.get(`${API_URL}/get_all_content_url`, {
        params: { content_type: contentType }
      });
      
      if (res.data) {
        const parser = new DOMParser();
        const doc = parser.parseFromString(res.data, 'text/html');
        const bodyContent = doc.body.innerHTML;
        setter(bodyContent || "");
      }
    } catch (error) {
      console.log("Content Fetch Error:", error);
      setter("<p>Content not available at the moment.</p>");
    } finally {
      setLoading(false);
    }
  };

  const fetchAboutUs = async () => {
    await fetchContentByType(0, setAboutUs);
  };

  const fetchTermsConditions = async () => {
    await fetchContentByType(2, setTermsConditions);
  };

  const fetchPrivacyPolicy = async () => {
    await fetchContentByType(1, setPrivacyPolicy);
  };

  const fetchContactUs = async () => {
    await fetchContentByType(6, setContactInfo);
  };



  const handleTabChange = (tab) => {
    setActiveTab(tab);
    if (tab === "about" && !aboutUs) {
      fetchAboutUs();
    } else if (tab === "terms" && !termsConditions) {
      fetchTermsConditions();
    } else if (tab === "privacy" && !privacyPolicy) {
      fetchPrivacyPolicy();
    } else if (tab === "help" && faqItems.length === 0) {
      fetchFaqItems();
    } else if (tab === "contact" && !contactInfo) {
      fetchContactUs();
    }
  };

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleContactFormChange = (e) => {
    setContactForm({ ...contactForm, [e.target.name]: e.target.value });
  };

  const handleContactSubmit = async (e) => {
    e.preventDefault();

    const userId = form.user_id || sessionStorage.getItem("id");
    const name = contactForm.name?.trim() || form.owner_name;
    const email = contactForm.email?.trim();
    const message = contactForm.message?.trim();

    if (!userId) {
      Swal.fire("Error", "User information is missing.", "error");
      return;
    }

    if (!name || !email || !message) {
      Swal.fire("Info", "Please fill in name, email and message.", "info");
      return;
    }

    try {
      const payload = {
        user_id: userId,
        name,
        email,
        message,
      };

      const res = await axios.post(`${API_URL}/contact_us`, payload, {
        headers: {
          Authorization: `Bearer ${sessionStorage.getItem("token")}`,
        },
      });

      if (res.data?.success) {
        Swal.fire("Success", res.data.msg || "Message sent successfully.", "success");
        setContactForm((prev) => ({
          ...prev,
          message: "",
        }));
      } else {
        Swal.fire("Error", res.data?.msg || "Unable to send message.", "error");
      }
    } catch (error) {
      console.error("Contact Us Error:", error);
      Swal.fire("Error", "Something went wrong while sending message.", "error");
    }
  };

  const handleBusinessTypeChange = (e) => {
    const value = e.target.value;
    const currentTypes = form.business_type ? form.business_type.split(',').map(id => parseInt(id)) : [];
    
    if (currentTypes.includes(parseInt(value))) {
      const updated = currentTypes.filter(id => id !== parseInt(value));
      setForm({ ...form, business_type: updated.join(',') });
    } else {
      setForm({ ...form, business_type: currentTypes.concat(parseInt(value)).join(',') });
    }
  };

  const handleCategoryChange = (e) => {
    const value = e.target.value;
    const currentCategories = form.category_ids ? form.category_ids.split(',').map(id => parseInt(id)) : [];
    
    if (currentCategories.includes(parseInt(value))) {
      const updated = currentCategories.filter(id => id !== parseInt(value));
      setForm({ ...form, category_ids: updated.join(',') });
    } else {
      setForm({ ...form, category_ids: currentCategories.concat(parseInt(value)).join(',') });
    }
  };

  const handleFileChange = (e) => {
    setImage(e.target.files[0]);
  };

  const handleAdminData = async (e) => {
    e.preventDefault();

    const data = new FormData();

    const fullMobile = form.phone_code + " " + form.mobile;
    const fullAltMobile = form.alternate_mobile ? form.altphone_code + " " + form.alternate_mobile : "";

    data.append("owner_name", form.owner_name);
    data.append("email", form.email);
    data.append("business_name", form.business_name);
    data.append("address", form.address);
    data.append("business_location", form.business_location);
    data.append("business_type", form.business_type);
    data.append("category_ids", form.category_ids);
    data.append("mobile", fullMobile);
    data.append("alternate_mobile", fullAltMobile);
    data.append("phone_code", form.phone_code);
    data.append("longitude", form.longitude);
    data.append("latitude", form.latitude);
    data.append("user_id", form.user_id);

    if (image && typeof image !== "string") {
      data.append("image", image);
    }

    try {
      const res = await axios.post(`${API_URL}/edit_profile`, data, {
        headers: {
          Authorization: `Bearer ${sessionStorage.getItem("token")}`,
        },
      });

      if (res.data.success) {
        const serverImageName = extractImageFromResponse(res.data);
        const finalImageValue =
          typeof image === "string"
            ? image
            : serverImageName || profileData.image || null;

        setImage(finalImageValue);

        Swal.fire({
          text: "Profile updated successfully",
          icon: "success",
        });

        const updatedUserData = {
          owner_name: form.owner_name,
          ownername: form.owner_name,
          email: form.email,
          business_name: form.business_name,
          businessname: form.business_name,
          address: form.address,
          business_location: form.business_location,
          business_type: form.business_type,
          dealing_id: form.category_ids
            ? form.category_ids.split(",").filter(Boolean)
            : [],
          mobile: `${form.phone_code} ${form.mobile}`.trim(),
          alternate_mobile: form.alternate_mobile
            ? `${form.altphone_code} ${form.alternate_mobile}`.trim()
            : "",
          phone_code: form.phone_code,
          altphone_code: form.altphone_code,
          longitude: form.longitude,
          latitude: form.latitude,
          user_id: form.user_id,
          image: finalImageValue,
        };

        updateSessionUserData(updatedUserData);
        fetchProfile();
      } else {
        Swal.fire({
          text: res.data.msg || "Something went wrong",
          icon: "error",
        });
      }
    } catch (error) {
      console.log("Update Error:", error);
    }
  };

  // Change Password States
  const [oldpassword, setOldPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confiremPassword, setConfirmPassword] = useState("");
  const [showOldPassword, setShowOldPassword] = useState(false);
  const [showNewPassword, setShowNewPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);

  const handleSubmitPassword = async (e) => {
    e.preventDefault();

    if (newPassword !== confiremPassword) {
      Swal.fire("Error", "New password & Confirm password must match", "error");
      return;
    }

    try {
      const user_id = sessionStorage.getItem("id");
      const data = { user_id, old_password:oldpassword, new_password:newPassword };
      const res = await axios.post(`${API_URL}/change_password`, data, {
        headers: {
          Authorization: `Bearer ${sessionStorage.getItem("token")}`,
        },
      });

      if (res.data.success) {
        Swal.fire("Success", "Password updated successfully", "success");
        setOldPassword("");
        setNewPassword("");
        setConfirmPassword("");
      } else {
        Swal.fire("Error", res.data.msg, "error");
      }
    } catch (error) {
      console.log("Password Update Error:", error);
    }
  };

  const handleDeleteAccount = async () => {
    Swal.fire({
      title: "Are you sure?",
      text: "This action cannot be undone. Your account will be permanently deleted!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      cancelButtonColor: "#3085d6",
      confirmButtonText: "Yes, delete it!",
      cancelButtonText: "Cancel"
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          const res = await axios.post(`${API_URL}/delete_account`, {
            user_id: form.user_id
          });

          if (res.data.success) {
            Swal.fire("Deleted!", "Your account has been deleted.", "success");
            setTimeout(() => {
              window.location.href = "/login";
            }, 2000);
          } else {
            Swal.fire("Error", res.data.msg || "Failed to delete account", "error");
          }
        } catch (error) {
          console.log("Delete Account Error:", error);
          Swal.fire("Error", "Something went wrong", "error");
        }
      }
    });
  };

  const getSelectedBusinessTypes = () => {
    if (!form.business_type) return [];
    return form.business_type.split(',').map(id => parseInt(id));
  };

  const getSelectedCategories = () => {
    if (!form.category_ids) return [];
    return form.category_ids.split(',').map(id => parseInt(id));
  };

  return (
    <div className="container mt-5">
      <Breadcrumbs title="Profile" items={[{ label: "Home" }, { label: "Profile" }]} />

      <div className="profile-tabs-container">
        <div className="profile-tabs">
          <button
            className={`profile-tab ${activeTab === "profile" ? "active" : ""}`}
            onClick={() => handleTabChange("profile")}
          >
            Edit Profile
          </button>

          <button
            className={`profile-tab ${activeTab === "changepwd" ? "active" : ""}`}
            onClick={() => handleTabChange("changepwd")}
          >
            Change Password
          </button>

          <button
            className={`profile-tab ${activeTab === "about" ? "active" : ""}`}
            onClick={() => handleTabChange("about")}
          >
            About Us
          </button>

          <button
            className={`profile-tab ${activeTab === "terms" ? "active" : ""}`}
            onClick={() => handleTabChange("terms")}
          >
            Terms & Conditions
          </button>

          <button
            className={`profile-tab ${activeTab === "privacy" ? "active" : ""}`}
            onClick={() => handleTabChange("privacy")}
          >
            Privacy Policy
          </button>

          <button
            className={`profile-tab ${activeTab === "contact" ? "active" : ""}`}
            onClick={() => handleTabChange("contact")}
          >
            Contact Us
          </button>

          <button
            className={`profile-tab ${activeTab === "help" ? "active" : ""}`}
            onClick={() => handleTabChange("help")}
          >
            Help / FAQ
          </button>
        </div>
      </div>

      <div className="profile-card">
        {/* EDIT PROFILE TAB */}
        {activeTab === "profile" && (
          <div className="profile-card-content">
            <h5 className="profile-title">Edit Profile</h5>
            
            <form onSubmit={handleAdminData}>
              <div className="row g-3">
                {/* Profile Image Upload */}
                <div className="col-12">
                  <div className="profile-image-section">
                    <div className="profile-image-preview">
                      <img
                        src={
                          image && typeof image !== "string"
                            ? URL.createObjectURL(image)
                            : image
                            ? `${IMAGE_PATH}${image}`
                            : `${IMAGE_PATH}placeholder.png`
                        }
                        alt="profile"
                        className="profile-img"
                      />
                    </div>
                    <div className="profile-image-upload-btn">
                      <label className="btn btn-outline-secondary">
                        Choose Profile Image
                        <input type="file" hidden onChange={handleFileChange} accept="image/*" />
                      </label>
                      {image && typeof image !== "string" && (
                        <p className="text-muted mt-2 mb-0">New image selected</p>
                      )}
                    </div>
                  </div>
                </div>

                {/* Name */}
                <div className="col-md-6">
                  <label className="form-label">Name</label>
                  <input
                    type="text"
                    name="owner_name"
                    value={form.owner_name}
                    onChange={handleChange}
                    className="form-control"
                  />
                </div>

                {/* Email */}
                <div className="col-md-6">
                  <label className="form-label">Email</label>
                  <input
                    type="email"
                    name="email"
                    value={form.email}
                    onChange={handleChange}
                    className="form-control"
                  />
                </div>

                {/* Business Name */}
                <div className="col-md-6">
                  <label className="form-label">Business Name</label>
                  <input
                    type="text"
                    name="business_name"
                    value={form.business_name}
                    onChange={handleChange}
                    className="form-control"
                  />
                </div>

                {/* Phone Code */}
                <div className="col-md-3">
                  <label className="form-label">Phone Code</label>
                  <input
                    type="text"
                    name="phone_code"
                    value={form.phone_code}
                    onChange={handleChange}
                    className="form-control"
                  />
                </div>

                {/* Mobile */}
                <div className="col-md-3">
                  <label className="form-label">Mobile Number</label>
                  <input
                    type="text"
                    name="mobile"
                    value={form.mobile}
                    onChange={handleChange}
                    className="form-control"
                  />
                </div>

                {/* Alt Phone Code */}
                <div className="col-md-3">
                  <label className="form-label">Phone Code</label>
                  <input
                    type="text"
                    name="altphone_code"
                    value={form.altphone_code}
                    onChange={handleChange}
                    className="form-control"
                  />
                </div>

                {/* Alternate Phone */}
                <div className="col-md-3">
                  <label className="form-label">Alternate Phone</label>
                  <input
                    type="text"
                    name="alternate_mobile"
                    value={form.alternate_mobile}
                    onChange={handleChange}
                    className="form-control"
                  />
                </div>

                {/* Address */}
                <div className="col-md-6">
                  <label className="form-label">Address</label>
                  <input
                    type="text"
                    name="address"
                    value={form.address}
                    onChange={handleChange}
                    className="form-control"
                  />
                </div>

                {/* Business Location */}
                <div className="col-md-6">
                  <label className="form-label">Business Location</label>
                  <input
                    type="text"
                    id="business_location_input"
                    name="business_location"
                    value={form.business_location}
                    onChange={handleChange}
                    className="form-control"
                  />
                </div>

                {/* Google Map */}
                <div className="col-12">
                  <div id="profile-map" className="google-map"></div>
                </div>

                {/* Business Type - Dropdown */}
                <div className="col-md-6">
                  <label className="form-label">Business Type</label>
                  <select
                    className="form-control"
                    value=""
                    onChange={handleBusinessTypeChange}
                  >
                    <option value="" disabled>Select Business Type</option>
                    {businessTypes.map((type) => (
                      <option key={type.id} value={type.id}>
                        {type.name}
                      </option>
                    ))}
                  </select>
                  {getSelectedBusinessTypes().length > 0 && (
                    <div className="selected-badges-container">
                      {getSelectedBusinessTypes().map((id) => {
                        const type = businessTypes.find(t => t.id === id);
                        return type ? (
                          <span key={id} className="badge bg-warning text-dark me-2 mb-2">
                            {type.name}
                            <button
                              type="button"
                              className="btn-close btn-close-white ms-2"
                              style={{ fontSize: '10px' }}
                              onClick={() => {
                                const updated = getSelectedBusinessTypes().filter(tid => tid !== id);
                                setForm({ ...form, business_type: updated.join(',') });
                              }}
                            ></button>
                          </span>
                        ) : null;
                      })}
                    </div>
                  )}
                </div>

                {/* Dealing With - Dropdown */}
                <div className="col-md-6">
                  <label className="form-label">Dealing With</label>
                  <select
                    className="form-control"
                    value=""
                    onChange={handleCategoryChange}
                  >
                    <option value="" disabled>Select Category</option>
                    {categories.map((cat) => (
                      <option key={cat.category_id} value={cat.category_id}>
                        {cat.category_name}
                      </option>
                    ))}
                  </select>
                  {getSelectedCategories().length > 0 && (
                    <div className="selected-badges-container">
                      {getSelectedCategories().map((id) => {
                        const cat = categories.find(c => c.category_id === id);
                        return cat ? (
                          <span key={id} className="badge bg-warning text-dark me-2 mb-2">
                            {cat.category_name}
                            <button
                              type="button"
                              className="btn-close btn-close-white ms-2"
                              style={{ fontSize: '10px' }}
                              onClick={() => {
                                const updated = getSelectedCategories().filter(cid => cid !== id);
                                setForm({ ...form, category_ids: updated.join(',') });
                              }}
                            ></button>
                          </span>
                        ) : null;
                      })}
                    </div>
                  )}
                </div>

                {/* Submit Button */}
                <div className="col-12">
                  <button type="submit" className="btn btn-register">
                    Update Profile
                  </button>
                </div>
              </div>
            </form>
          </div>
        )}

        {/* CHANGE PASSWORD TAB */}
        {activeTab === "changepwd" && (
          <div className="profile-card-content">
            <h5 className="profile-title">Change Password</h5>
            
            <form onSubmit={handleSubmitPassword}>
              <div className="row g-3">
                <div className="col-12">
                  <label className="form-label">Old Password</label>
                  <div className="password-input-wrapper">
                    <input
                      type={showOldPassword ? "text" : "password"}
                      className="form-control"
                      value={oldpassword}
                      onChange={(e) => setOldPassword(e.target.value)}
                      required
                    />
                    <span 
                      className="password-toggle-icon" 
                      onClick={() => setShowOldPassword(!showOldPassword)}
                    >
                      {showOldPassword ? <RiEyeFill /> : <RiEyeOffFill />}
                    </span>
                  </div>
                </div>

                <div className="col-md-6">
                  <label className="form-label">New Password</label>
                  <div className="password-input-wrapper">
                    <input
                      type={showNewPassword ? "text" : "password"}
                      className="form-control"
                      value={newPassword}
                      onChange={(e) => setNewPassword(e.target.value)}
                      required
                    />
                    <span 
                      className="password-toggle-icon" 
                      onClick={() => setShowNewPassword(!showNewPassword)}
                    >
                      {showNewPassword ? <RiEyeFill /> : <RiEyeOffFill />}
                    </span>
                  </div>
                </div>

                <div className="col-md-6">
                  <label className="form-label">Confirm Password</label>
                  <div className="password-input-wrapper">
                    <input
                      type={showConfirmPassword ? "text" : "password"}
                      className="form-control"
                      value={confiremPassword}
                      onChange={(e) => setConfirmPassword(e.target.value)}
                      required
                    />
                    <span 
                      className="password-toggle-icon" 
                      onClick={() => setShowConfirmPassword(!showConfirmPassword)}
                    >
                      {showConfirmPassword ? <RiEyeFill /> : <RiEyeOffFill />}
                    </span>
                  </div>
                </div>

                <div className="col-12">
                  <button type="submit" className="btn btn-register">
                    Update Password
                  </button>
                </div>
              </div>
            </form>
          </div>
        )}

        {/* ABOUT US TAB */}
        {activeTab === "about" && (
          <div className="profile-card-content">
            <h5 className="profile-title">About Us</h5>
            {loading ? (
              <div className="text-center py-5">
                <div className="spinner-border text-primary" role="status">
                  <span className="visually-hidden">Loading...</span>
                </div>
              </div>
            ) : (
              <div className="content-display" dangerouslySetInnerHTML={{ __html: aboutUs || "<p>No information available.</p>" }} />
            )}
          </div>
        )}

        {/* TERMS TAB */}
        {activeTab === "terms" && (
          <div className="profile-card-content">
            <h5 className="profile-title">Terms & Conditions</h5>
            {loading ? (
              <div className="text-center py-5">
                <div className="spinner-border text-primary" role="status">
                  <span className="visually-hidden">Loading...</span>
                </div>
              </div>
            ) : (
              <div className="content-display" dangerouslySetInnerHTML={{ __html: termsConditions || "<p>No terms and conditions available.</p>" }} />
            )}
          </div>
        )}

        {/* PRIVACY TAB */}
        {activeTab === "privacy" && (
          <div className="profile-card-content">
            <h5 className="profile-title">Privacy Policy</h5>
            {loading ? (
              <div className="text-center py-5">
                <div className="spinner-border text-primary" role="status">
                  <span className="visually-hidden">Loading...</span>
                </div>
              </div>
            ) : (
              <div
                className="content-display"
                dangerouslySetInnerHTML={{
                  __html: privacyPolicy || "<p>No privacy policy available.</p>",
                }}
              />
            )}
          </div>
        )}

        {/* CONTACT US TAB */}
        {activeTab === "contact" && (
          <div className="profile-card-content">
            <div className="contact-help-wrapper">
              <div className="contact-form-card">
                <div className="contact-form-header">
                  <h5>Contact Us</h5>
                  <p>Tell us how we can help you and we’ll get back shortly.</p>
                </div>
                <form onSubmit={handleContactSubmit}>
                  <label className="form-label">Name</label>
                  <div className="input-with-icon">
                    <FiUser />
                    <input
                      type="text"
                      name="name"
                      value={contactForm.name}
                      onChange={handleContactFormChange}
                      placeholder="Your name"
                      className="form-control"
                    />
                  </div>

                  <label className="form-label">Email</label>
                  <div className="input-with-icon">
                    <FiMail />
                    <input
                      type="email"
                      name="email"
                      value={contactForm.email}
                      onChange={handleContactFormChange}
                      placeholder="you@example.com"
                      className="form-control"
                    />
                  </div>

                  <label className="form-label mt-3">Message</label>
                  <div className="input-with-icon textarea">
                    <FiMessageSquare />
                    <textarea
                      name="message"
                      rows="4"
                      value={contactForm.message}
                      onChange={handleContactFormChange}
                      placeholder="Tell us how we can help you..."
                      className="form-control"
                    ></textarea>
                  </div>

                  <button type="submit" className="btn btn-contact">
                    <FiSend />
                    Send Message
                  </button>
                </form>
              </div>

              <div className="contact-info-card">
                <h6>Contact Information</h6>
                <p>Reach out to us through any of the channels below.</p>
                {contactInfo ? (
                  <ul className="contact-info-list">
                    <li>
                      <span className="icon">
                        <FiMail />
                      </span>
                      <div>
                        <p>Email</p>
                        <strong>{parsedContactInfo.email || "Not available"}</strong>
                      </div>
                    </li>
                    <li>
                      <span className="icon">
                        <FiPhone />
                      </span>
                      <div>
                        <p>Phone</p>
                        <strong>{parsedContactInfo.phone || "Not available"}</strong>
                      </div>
                    </li>
                    <li>
                      <span className="icon">
                        <FiGlobe />
                      </span>
                      <div>
                        <p>Website</p>
                        <strong>{parsedContactInfo.website || "Not available"}</strong>
                      </div>
                    </li>
                    <li>
                      <span className="icon">
                        <FiMapPin />
                      </span>
                      <div>
                        <p>Address</p>
                        <strong>{parsedContactInfo.address || "Not available"}</strong>
                      </div>
                    </li>
                  </ul>
                ) : (
                  <p className="text-muted mb-0">
                    Contact information is not available right now. Please check back later.
                  </p>
                )}
              </div>
            </div>
          </div>
        )}

        {/* HELP / FAQ TAB */}
        {activeTab === "help" && (
          <div className="profile-card-content">
            <div className="help-hero-card">
              <div className="hero-icon">
                <FiHelpCircle />
              </div>
              <div>
                <h5>How can we help you?</h5>
                <p>Find answers to common questions or get in touch with support.</p>
              </div>
            </div>

            <div className="faq-section">
              <h6>Frequently Asked Questions</h6>
              {faqLoading ? (
                <div className="text-center py-4">
                  <div className="spinner-border text-primary" role="status">
                    <span className="visually-hidden">Loading...</span>
                  </div>
                </div>
              ) : faqItems.length > 0 ? (
                <div className="faq-accordion">
                  {faqItems.map((faq, index) => (
                    <details key={`${faq.question}-${index}`} open={index === 0}>
                      <summary>
                        <span>{faq.question}</span>
                        <FiChevronDown />
                      </summary>
                      <p>{faq.answer}</p>
                    </details>
                  ))}
                </div>
              ) : (
                <p className="text-muted mb-0">
                  FAQs are not available right now. Please check back later.
                </p>
              )}
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default Profile;